import {IconButton, Tooltip} from "@chakra-ui/react";
import {BiHelpCircle} from "react-icons/bi";

const DOCS_BASE_URL = "https://docs.soundspots.app";

type Props = {
    path: string;
    label?: string;
    size?: "xs" | "sm" | "md" | "lg";
};

const HelpLink = ({path, label, size}: Props) => {
    const url = `${DOCS_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
    const tooltipLabel = label || "Open documentation";
    return (
        <Tooltip label={tooltipLabel}>
            <IconButton
                as={"a"}
                href={url}
                target={"_blank"}
                rel={"noopener noreferrer"}
                aria-label={tooltipLabel}
                icon={<BiHelpCircle/>}
                size={size || "sm"}
                variant={"ghost"}
            />
        </Tooltip>
    );
};

export default HelpLink;
